export const serverURL = process.env.REACT_APP_SERVER_BASE_URL;
export const apiURL = `${serverURL}/api/`;